import { deviceType } from "@tm/isomorphic-utils";
import { H3TagStyle } from "@tm/ui-widgets/components";
import styled from "styled-components";

export const InsuranceLandingPageMainWrapper = styled.div`
  background-image: linear-gradient(rgba(5, 19, 34, 1), rgba(21, 69, 124, 1));
  background-size: 100% 990px;
  background-repeat: no-repeat;
  padding-top: 16px;
  position: relative;
  z-index: 2;
  @media ${deviceType.mobile} {
    background-image: none;
    /* background: #000; */
    padding-top: 0px;
  }
`;

export const InsuranceGiLandingPageMainWrapper = styled.div`
  padding-top: 16px;
  position: relative;
  z-index: 2;
  &:after {
    content: "";
    position: absolute;
    top: 240px;
    width: 100%;
    left: 0;
    background-color: #eff3f8;
    height: 1200px;
    z-index: 1;
  }
  :before {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    left: 0;
    background-image: url("https://tripmoneycmsimgak.mmtcdn.com/img/Group_1244831888_401a4765df.png");
    background-size: 100% 382px;
    background-repeat: no-repeat;
    height: 382px;
    z-index: 2;
  }
  @media ${deviceType.mobile} {
    background-image: none;
    /* background: #000; */
    padding-top: 0px;
    &:after {
      background-color: transparent;
    }
  }
`;

export const PersuasionWrapper = styled.div`
  width: 1200px;
  margin: 0 auto;
  ${H3TagStyle} {
    max-width: 60%;
  }
`;

export const LandingPageRightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const GiFooterWrap = styled.div`
  width: 100%;
`;
